import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { resetDocument, updatePrompt } from "../_actions/aiDocumentActions";
import _ from "lodash";
import TldrObjectives from "./TldrObjectives";
import AITemplates from "./AITemplates";
import AiInputForm from "./AiInputForms/AiInputForm";
import TldrAiBase from "./TldrAiBase";
import { Box } from "@chakra-ui/react";
import { useHistory, useParams } from "react-router-dom";
import Format from "string-format";
import { AI_WRITER_SCREEN } from "../_utils/routes";

const formBaseStyles = {
  maxWidth:["90%","90%","50%"],
  mx:"auto",
  ".card":{
    borderRadius:"8px",
    minHeight:"300px",
  }
}
const AutoGeneration = (props) => {
  let _isMounted = true;
  const { tab } = props;
  const [selectedTab, setSelectedTab] = useState(tab);
  const [wizardData, setWizardData] = useState({});
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const history = useHistory();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const params = useParams();

  const onComplete = (step, data, extra) => {
    if (_isMounted) {
      if (step === "welcome") {
        setWizardData({ ...wizardData, welcome: data });
        setSelectedTab("goals");
      } else if (step === "goals") {
        const url = Format(AI_WRITER_SCREEN, data.slug);
        history.push({
          pathname: encodeURI(url),
        });
        setWizardData({ ...wizardData, goals: data });
        setSelectedTab("info");
      } else {
        setSelectedTab("welcome");
      }
    }
  };

  const checkMobileViewState = () => {
    if (_isMounted) {
      if (window.innerWidth < 768) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
  };

  useEffect(() => {
    _isMounted = true;
    dispatch(resetDocument());
    window.addEventListener(
      "resize",
      _.debounce(() => {
        checkMobileViewState();
      }, 100)
    );
    return () => {
      _isMounted = false;
      window.removeEventListener("resize", checkMobileViewState);
    };
  }, []);

  let content = (
    <Box w={"100%"}>
      {selectedTab === "welcome" ? (
        <TldrObjectives onComplete={onComplete}></TldrObjectives>
      ) : selectedTab === "info" ? (
        <Box
          w="100%"
          m={["0", "auto", "0", "auto"]}
          p="0"
        >
          <AiInputForm
            resultsView={false}
            prompt={wizardData.goals}
            onComplete={onComplete}
          ></AiInputForm>
        </Box>
      ) : selectedTab === "goals" ? (
        <AITemplates
          data={wizardData.welcome}
          onComplete={onComplete}
        ></AITemplates>
      ) : (
        <></>
      )}
    </Box>
  );

  return (
    <>
      {selectedTab === "welcome" ? (
        content
      ) : (
        <>
          <Box as={TldrAiBase} className="ai-base-card" sx={formBaseStyles}>
            {content}
          </Box>
        </>
      )}
    </>
  );
};

AutoGeneration.propTypes = {
  tab: PropTypes.string,
};

AutoGeneration.defaultProps = {
  tab: "welcome",
};

export default AutoGeneration;
